import { WandMagicSparkles } from "flowbite-react-icons/solid";
import { useCallback, useRef } from "preact/hooks";
import PropTypes from "prop-types";

DemoAnimationsDropdown.propTypes = {
  onChosen: PropTypes.func,
  disabled: PropTypes.bool,
  milestone: PropTypes.bool,
  goal: PropTypes.bool,
  goalAfter: PropTypes.bool,
};

export default function DemoAnimationsDropdown({
  onChosen,
  disabled = false,
  milestone = true,
  goal = true,
  goalAfter = true,
}) {
  const detailsRef = useRef();
  const handleClick = useCallback(
    (animation) => {
      onChosen(animation);
      detailsRef.current.open = false;
    },
    [onChosen],
  );

  return (
    <div className="absolute bottom-1 left-1 right-1 flex items-center justify-center z-40">
      <div className="flex-grow">
        <details
          ref={detailsRef}
          className="dropdown dropdown-top tooltip tooltip-right"
          data-tip="Demo Animations"
        >
          {/** biome-ignore lint/a11y/noStaticElementInteractions: Needed to keep track of state */}
          <summary
            onClick={(e) => (disabled ? e.preventDefault() : null)}
            tabIndex={0}
            className={`btn btn-sm btn-circle btn-ghost border-0 bg-white m-1 ${disabled ? "bg-gray-900 text-gray-500 pointer-events-none" : "text-secondary"}`}
          >
            <WandMagicSparkles />
          </summary>
          <ul className="menu dropdown-content bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
            {goal && (
              <li>
                <button type="button" onClick={() => handleClick("goal")}>
                  Goal Met Animation
                </button>
              </li>
            )}
            {milestone && (
              <li>
                <button type="button" onClick={() => handleClick("milestone")}>
                  Milestone Animation
                </button>
              </li>
            )}
            {goalAfter && (
              <li>
                <button type="button" onClick={() => handleClick("goalAfter")}>
                  Goal After Met
                </button>
              </li>
            )}
          </ul>
        </details>
      </div>
    </div>
  );
}
